import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('auth.validation.emailInvalid'),
  password: z.string().min(1, 'auth.validation.passwordRequired'),
});

export const registerSchema = z.object({
  fullName: z.string().min(2, 'auth.validation.fullNameMin'),
  email: z.string().email('auth.validation.emailInvalid'),
  password: z
    .string()
    .min(12, 'auth.validation.passwordMin')
    .regex(/[A-Z]/, 'auth.validation.passwordUppercase')
    .regex(/[a-z]/, 'auth.validation.passwordLowercase')
    .regex(/[0-9]/, 'auth.validation.passwordNumber'),
  locale: z.enum(['ar', 'en']),
});

export const forgotPasswordSchema = z.object({
  email: z.string().email('auth.validation.emailInvalid'),
});

export const newPasswordSchema = z
  .object({
    newPassword: z
      .string()
      .min(12, 'auth.validation.passwordMin')
      .regex(/[A-Z]/, 'auth.validation.passwordUppercase')
      .regex(/[a-z]/, 'auth.validation.passwordLowercase')
      .regex(/[0-9]/, 'auth.validation.passwordNumber'),
    confirmPassword: z.string().min(1, 'auth.validation.confirmPasswordRequired'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'auth.validation.passwordsMustMatch',
    path: ['confirmPassword'],
  });

export const resetPasswordSchema = z
  .object({
    token: z.string().min(1, 'auth.validation.tokenRequired'),
    newPassword: z
      .string()
      .min(12, 'auth.validation.passwordMin')
      .regex(/[A-Z]/, 'auth.validation.passwordUppercase')
      .regex(/[a-z]/, 'auth.validation.passwordLowercase')
      .regex(/[0-9]/, 'auth.validation.passwordNumber'),
    confirmPassword: z.string().min(1, 'auth.validation.confirmPasswordRequired'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'auth.validation.passwordsMustMatch',
    path: ['confirmPassword'],
  });

export const verifyEmailSchema = z.object({
  token: z.string().min(1),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
export type RegisterFormValues = z.infer<typeof registerSchema>;
export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;
export type NewPasswordFormValues = z.infer<typeof newPasswordSchema>;
export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;
